export class SoLongRunDetails{
    
        poNumber: string;
        invoiceDate: string;
        actEdlDate: string;
        vCode: string;
      
}